import { render, staticRenderFns } from "./addOrEditCustomer.vue?vue&type=template&id=bc1a0564&scoped=true&"
import script from "./addOrEditCustomer.vue?vue&type=script&lang=js&"
export * from "./addOrEditCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1a0564",
  null
  
)

export default component.exports